<template>
    <div class="record-company"/>
</template>

<script>
    export default {
        name: 'RecordCompany',
    }
</script>
